import { ItemUrls } from '../api/item-urls';
import { ItemWithSinistersUrls } from '../api/item-with-sinisters';

export * from '../api/item-urls';

export const EndPoints = {
    ItemUrls,
    ItemWithSinistersUrls
}
